module.exports = __webpack_public_path__ + "static/media/Insurance.3dd6ae47.png";